import { render, staticRenderFns } from "./RevisionLink.vue?vue&type=template&id=3f954a60&"
import script from "./RevisionLink.vue?vue&type=script&lang=js&"
export * from "./RevisionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports